import {
  CancelRequestCoreCommandParams,
  Command,
  CreateCollectionCoreCommandParams,
  CreateNetworkCoreCommandParams,
  DeleteAccountCoreCommandParams,
  RequestCollectionAccessCoreCommandParams,
  RequestCollectionOwnershipCoreCommandParams,
  RequestCollectionTransferCoreCommandParams,
  RequestFileAccessCoreCommandParams,
  RequestFileOwnershipCoreCommandParams,
  RequestFileTransferCoreCommandParams,
  TransferTokenCoreCommandParams,
  UpdateAccountDetailsCoreCommandParams,
  UpdateCollectionCoreCommandParams,
  UpdateFileCoreCommandParams,
  UpdateNetworkCoreCommandParams,
} from '@stellab/cs-schemas';

import { postCommand } from './axios';

export const sendRequestFileOwnershipCommand = async (
  passphrase: string,
  params: RequestFileOwnershipCoreCommandParams,
) => {
  return postCommand({
    command: Command.RequestFileOwnership,
    passphrase,
    params,
  });
};

export const sendRequestFileAccessCommand = async (passphrase: string, params: RequestFileAccessCoreCommandParams) => {
  return postCommand({
    command: Command.RequestFileAccess,
    passphrase,
    params,
  });
};

export const sendRequestFileTransferCommand = async (
  passphrase: string,
  params: RequestFileTransferCoreCommandParams,
) => {
  return postCommand({
    command: Command.RequestFileTransfer,
    passphrase,
    params,
  });
};

export const sendUpdateFileCommand = async (passphrase: string, params: UpdateFileCoreCommandParams) => {
  return postCommand({
    command: Command.UpdateFile,
    passphrase,
    params,
  });
};

export const sendCreateCollectionCommand = async (passphrase: string, params: CreateCollectionCoreCommandParams) => {
  return postCommand({
    command: Command.CreateCollection,
    passphrase,
    params,
  });
};

export const sendUpdateCollectionCommand = async (passphrase: string, params: UpdateCollectionCoreCommandParams) => {
  return postCommand({
    command: Command.UpdateCollection,
    passphrase,
    params,
  });
};

export const sendRequestCollectionOwnershipCommand = async (
  passphrase: string,
  params: RequestCollectionOwnershipCoreCommandParams,
) => {
  return postCommand({
    command: Command.RequestCollectionOwnership,
    passphrase,
    params,
  });
};

export const sendRequestCollectionAccessCommand = async (
  passphrase: string,
  params: RequestCollectionAccessCoreCommandParams,
) => {
  return postCommand({
    command: Command.RequestCollectionAccess,
    passphrase,
    params,
  });
};

export const sendRequestCollectionTransferCommand = async (
  passphrase: string,
  params: RequestCollectionTransferCoreCommandParams,
) => {
  return postCommand({
    command: Command.RequestCollectionTransfer,
    passphrase,
    params,
  });
};

export const sendCancelRequestCommand = async (passphrase: string, params: CancelRequestCoreCommandParams) => {
  return postCommand({
    command: Command.CancelRequest,
    passphrase,
    params,
  });
};

export const sendUpdateAccountDetailsCommand = async (
  passphrase: string,
  params: UpdateAccountDetailsCoreCommandParams,
) => {
  return postCommand({
    command: Command.UpdateAccountDetails,
    passphrase,
    params,
  });
};

export const sendCreateNetworkCommand = async (passphrase: string, params: CreateNetworkCoreCommandParams) => {
  return postCommand({
    command: Command.CreateNetwork,
    passphrase,
    params,
  });
};

export const sendUpdateNetworkCommand = async (passphrase: string, params: UpdateNetworkCoreCommandParams) => {
  return postCommand({
    command: Command.UpdateNetwork,
    passphrase,
    params,
  });
};

export const sendTransferTokenCommand = async (passphrase: string, params: TransferTokenCoreCommandParams) => {
  return postCommand({
    command: Command.Transfer,
    passphrase,
    params,
  });
};

export const sendDeleteAccountCommand = async (passphrase: string, params: DeleteAccountCoreCommandParams) => {
  return postCommand({
    command: Command.DeleteAccount,
    passphrase,
    params,
  });
};
